// Импорт скриптов из pages/auth-registration/init.js
import './init';
